<template>
  <div class="journalismDetails">
    <pcHeader></pcHeader>
    <!-- 普通影像 -->
    <div class="context_box">
      <div class="context">
        <div class="title">
          {{ dataList.atlasAndVideoResult.newsTitle }}
        </div>
        <div class="source_time">
          <div class="source">{{ dataList.atlasAndVideoResult.organizationName }}</div>
          <div>
            <!-- {{
              dataList.atlasAndVideoResult.clubOuterName
                ? dataList.atlasAndVideoResult.clubOuterName
                : dataList.atlasAndVideoResult.nickName
            }} -->
            {{ dataList.atlasAndVideoResult.clubOuterName }}
          </div>

          <div class="time">{{ dataList.atlasAndVideoResult.putawayTime }}</div>
          <div class="quantity">
            <van-icon name="eye-o" />
            {{ dataList.atlasAndVideoResult.examineNumber }}
          </div>
        </div>
        <div
          style="
            text-indent: 2em;
            text-align: initial;
            width: 910px;
            padding: 0 55px;
            color: #222;
            font-size: 18px;
            box-sizing: border-box;
            padding-bottom: 20px;
          "
          v-html="dataList.atlasAndVideoResult.newsExplain"
        ></div>
        <!-- 轮播图片 -->
        <div class="swipe_img">
          <swiper ref="demoSwiper" :options="swiperOption" @slideChange="change()">
            <div
              class="swiper-button-prev"
              slot="button-prev"
              v-show="dataList.atlasAndVideoResult.subDescriptionNewsAtlasVos.length > 1"
            ></div>
            <swiper-slide
              v-for="(item, index) in dataList.atlasAndVideoResult.subDescriptionNewsAtlasVos"
              :key="index"
            >
              <div>
                <div class="item_container">
                  <div class="loading_box" v-if="imageLoading">
                    <van-loading color="f5f5f5" type="spinner" />
                  </div>
                  <img v-else :src="item.coverImages" alt="" class="apparatus_logo" />

                  <div class="position">
                    <div style="display: flex; justify-content: space-between">
                      <div>
                        <span style="font-size: 20px"> {{ index + 1 }}</span
                        >/
                        <span style="font-size: 20px">{{
                          dataList.atlasAndVideoResult.subDescriptionNewsAtlasVos.length
                        }}</span>
                      </div>
                      <div style="font-size: 14px; letter-spacing: -0.3px; color: #999999">
                        {{ $t('message.news.PictureName') }}：{{
                          dataList.atlasAndVideoResult.subDescriptionNewsAtlasVos[activeIndex]
                            .rawImage
                        }}
                      </div>
                    </div>

                    <!-- <div
                      style="text-align: initial"
                      v-html="dataList.atlasAndVideoResult.newsExplain"
                    ></div> -->
                  </div>
                </div>
              </div>
            </swiper-slide>

            <div
              class="swiper-button-next"
              slot="button-next"
              v-show="dataList.atlasAndVideoResult.subDescriptionNewsAtlasVos.length > 1"
            ></div>
          </swiper>

          <div
            v-if="dataList.atlasAndVideoResult.subDescriptionNewsAtlasVos[activeIndex].pointsThat"
            style="
              width: 800px;
              color: #222;
              padding: 0 55px;
              box-sizing: border-box;
              margin: 10px 0;
            "
          >
            <div
              style="
                background-color: #f5f5f5;
                box-sizing: border-box;
                border-radius: 4px;
                /* padding: 10px; */
                text-align: initial;
                width: 800px;
                padding: 10px 15px;
                box-sizing: border-box;
                font-size: 18px;
                padding-bottom: 10px;
                text-indent: 2em;
                white-space: normal;
              "
            >
              {{ dataList.atlasAndVideoResult.subDescriptionNewsAtlasVos[activeIndex].pointsThat }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pcHeader from '@/components/pcHeader'
import { newsGetNews } from '@/api/journalism.js'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: { pcHeader, Swiper, SwiperSlide },
  data() {
    return {
      imageLoading: true,
      dataList: {
        atlasAndVideoResult: {
          subDescriptionNewsAtlasVos: [{}]
        },
        imageTextResult: {}
      },
      activeIndex: 0,
      swiperOption: {
        direction: 'horizontal',
        //轮播设置
        autoplay: false,
        // loop: true,
        // loopFillGroupWithBlank: true,
        observer: true,
        observeParents: true,
        // slidesPerView: 3,
        // preventClicks :false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 是否开启拖动
        allowTouchMove: true,
        centeredSlides: true
      }
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  watch: {},
  created() {
    this.search()
  },
  methods: {
    async search() {
      const { data: res } = await newsGetNews({
        id: this.id
      })
      if (res.resultCode == 200) {
        this.dataList = res.data
        this.imageLoading = false
      }
    },
    change(e) {
      this.activeIndex = this.$refs.demoSwiper.$swiper.activeIndex
    }
  }
}
</script>
<style scoped lang="less">
.journalismDetails {
  .context_box {
    width: 100%;
    display: flex;
    justify-content: center;
    .context {
      width: 897px;
      padding-top: 24px;
      .title {
        padding: 0 55px;
        font-size: 30px;
        font-weight: 600;
        color: #1a1a1a;
      }
      .source_time {
        padding: 0 55px;
        font-size: 14px;
        color: #666666;
        display: flex;
        margin: 12px 0 18px 0;

        .time {
          margin: 0 14px 0 21px;
        }
      }

      .swipe_img {
        width: 910px;
        // height: 533px;
        max-height: 560px;

        .item_container {
          width: 910px;
          padding: 0 55px;
          box-sizing: border-box;
          img {
            border-radius: 4px;
            max-width: 800px;
            max-height: 533px;
            object-fit: contain;
          }
          .position {
            display: flex;
            flex-direction: column;
          }
        }

        .swiper-container {
          font-size: 0;
          width: 100%;
          height: 100%;
          // padding-bottom: 20px;
        }

        .swiper-slide {
          text-align: center;
          display: flex;
          align-items: center;
          font-size: 18px;
          -webkit-transition: transform 0.1s;
          -moz-transition: transform 0.1s;
          -ms-transition: transform 0.1s;
          -o-transition: transform 0.1s;
          -webkit-transform: scale(0.85);
          transform: scale(0.85);
        }

        .swiper-slide-active,
        .swiper-slide-duplicate-active {
          -webkit-transform: scale(1);
          transform: scale(1);
        }

        .swiper-slide img {
          width: 100%;
          height: 100%;
        }

        .swiper-button-prev::after {
          transform: translateX(-2px);
          font-size: 18px;
          color: #fff;
        }
        .swiper-button-next {
          width: 50px;
          height: 60px;
          background-color: rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          right: 0;
        }
        .swiper-button-prev {
          width: 50px;
          height: 60px;
          background-color: rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          left: 0;
        }
        .swiper-button-next::after {
          transform: translateX(2px);
          font-size: 18px;
          color: #fff;
        }
        .swiper-button-prev,
        .swiper-button-next {
          color: rgb(88, 105, 133);
        }
      }
    }
  }
}
</style>
